var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.diagramData)?_c('div',[(_vm.diagramData.length > 0)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.createIcon(_vm.diagramData, false))}}):_vm._e(),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"text"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }